import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { getAllMerchantAction } from "store/actions/restaurantAction";

const MerchantDrop = ({ merchant, setMerchant }) => {
  const dispatch = useDispatch();
  const { merchantData } = useSelector((state) => state.restaurant);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleSelect = (value) => {
    setMerchant(value);
  };

  useEffect(() => {
    dispatch(getAllMerchantAction());
  }, [dispatch]);

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      direction="down"
      className="w-100"
    >
      <DropdownToggle
        color="danger"
        className="btn btn-danger w-100 text-truncate"
        caret
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={merchant?.name || "All Merchants"}
      >
        {merchant?.name || "All Merchants"}
      </DropdownToggle>

      <DropdownMenu
        className="w-100 overflow-auto"
        style={{ maxHeight: "300px" }}
      >
        <DropdownItem
          key={""}
          onClick={() => handleSelect("")}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={"All Merchants"}
        >
          All Merchants
        </DropdownItem>
        {merchantData?.map((merchant) => (
          <DropdownItem
            key={merchant.id}
            onClick={() => handleSelect(merchant)}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={merchant?.name}
          >
            {merchant?.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default MerchantDrop;
